// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-b171a315] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.progress-bar[data-v-b171a315] {
  display: block;
  height: var(--progress-bar-height);
  width: 100%;
  overflow: hidden;
  border: 0;
  padding: 0;
  background: var(--color-background-dark);
  border-radius: calc(var(--progress-bar-height) / 2);
}
.progress-bar[data-v-b171a315]::-webkit-progress-bar {
  height: var(--progress-bar-height);
  background-color: transparent;
}
.progress-bar[data-v-b171a315]::-webkit-progress-value {
  background: var(--gradient-primary-background);
  border-radius: calc(var(--progress-bar-height) / 2);
}
.progress-bar[data-v-b171a315]::-moz-progress-bar {
  background: var(--gradient-primary-background);
  border-radius: calc(var(--progress-bar-height) / 2);
}
.progress-bar--error[data-v-b171a315]::-moz-progress-bar {
  background: var(--color-error) !important;
}
.progress-bar--error[data-v-b171a315]::-webkit-progress-value {
  background: var(--color-error) !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-61b63a8f.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,mDAAmD;AACrD;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,8CAA8C;EAC9C,mDAAmD;AACrD;AACA;EACE,8CAA8C;EAC9C,mDAAmD;AACrD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-b171a315] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.progress-bar[data-v-b171a315] {\n  display: block;\n  height: var(--progress-bar-height);\n  width: 100%;\n  overflow: hidden;\n  border: 0;\n  padding: 0;\n  background: var(--color-background-dark);\n  border-radius: calc(var(--progress-bar-height) / 2);\n}\n.progress-bar[data-v-b171a315]::-webkit-progress-bar {\n  height: var(--progress-bar-height);\n  background-color: transparent;\n}\n.progress-bar[data-v-b171a315]::-webkit-progress-value {\n  background: var(--gradient-primary-background);\n  border-radius: calc(var(--progress-bar-height) / 2);\n}\n.progress-bar[data-v-b171a315]::-moz-progress-bar {\n  background: var(--gradient-primary-background);\n  border-radius: calc(var(--progress-bar-height) / 2);\n}\n.progress-bar--error[data-v-b171a315]::-moz-progress-bar {\n  background: var(--color-error) !important;\n}\n.progress-bar--error[data-v-b171a315]::-webkit-progress-value {\n  background: var(--color-error) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
